<template>
    <div class=""></div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
    props: {
        apiKey: {
            type: String,
            default: "",
        },
    },
    computed: {},
    data() {
        return {
            //googlePlaces: null,
            googleAutocomplete: null,
            googleGeocoder: null,

            serviceLoading: false,
        };
    },
    mounted() {
        if (this.isLoadingGmap()) {
            (async () => {
                this.serviceLoading = true;

                await this.onLoadingGmap();
                this.initGoogleServices(window.google.maps);

                this.serviceLoading = false;
            })();
        } else {
            try {
                this.serviceLoading = true;

                this.initGoogleServices(window.google.maps);

                this.serviceLoading = false;
            } catch (e) {
                (async () => {
                    this.serviceLoading = true;

                    this.initGoogleServices(await this.loadLibrary());

                    this.serviceLoading = false;
                })();
            }
        }
    },
    methods: {
        getAddress(selectedPlace) {
            const { formatted_address = "" } = selectedPlace || {};

            return formatted_address;
        },
        getCity(selectedPlace) {
            if (!selectedPlace) {
                return null;
            }

            const { address_components = [] } = selectedPlace;

            let city = "";
            for (let { types = [], short_name } of address_components) {
                if (!types.length) continue;
                const [type] = types;

                switch (type) {
                    case "administrative_area_level_3":
                        return short_name;
                        break;
                    case "locality":
                        city = short_name;
                        break;
                }
            }

            return city;
        },
        getGeometry(selectedPlace) {
            if (!selectedPlace) {
                return null;
            }

            return selectedPlace.geometry;
        },
        getLatLng(selectedPlace) {
            if (!selectedPlace) {
                return null;
            }

            let location = null;
            try {
                location = this.getGeometry(selectedPlace).location || location;
            } catch (e) {}

            const { lat = () => "", lng = () => "" } = location;

            return {
                lat: lat(),
                lng: lng(),
            };
        },
        initGoogleServices({ places, Geocoder } = window.google.maps) {
            this.googleGeocoder = new Geocoder();
            this.googleAutocomplete = new places.AutocompleteService();
        },
        async loadLibrary() {
            this.setLoadingGmap(true);
            return new Promise((resolve, reject) => {
                const callbackName = "gmaps" + uniqueId();
                window[callbackName] = () => {
                    this.setLoadingGmap(false);
                    resolve(google.maps);
                };
                let language = document.documentElement.lang
                    ? document.documentElement.lang
                    : "en";

                const url =
                    "https://maps.googleapis.com/maps/api/js?key=" +
                    this.apiKey +
                    "&libraries=places&language=" +
                    language +
                    "&callback=" +
                    callbackName;
                const script = document.createElement("script");
                script.src = url;
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            });
        },
        setLoadingGmap(isLoading) {
            this.$root.$data.loadingGmap = isLoading;
            this.$root.$emit("loadingGmap", isLoading);
        },
        isLoadingGmap() {
            return this.$root.$data.loadingGmap;
        },
        async onLoadingGmap() {
            return new Promise((resolve, reject) => {
                this.$root.$once("loadingGmap", (isLoading) => {
                    if (!isLoading) {
                        resolve();
                    }
                });
            });
        },
        async geocode({ placeId, address } = {}) {
            return new Promise((resolve, reject) => {
                this.serviceLoading = true;

                this.googleGeocoder.geocode({ placeId }, (results, status) => {
                    this.serviceLoading = false;

                    switch (status) {
                        case google.maps.GeocoderStatus.OK:
                            //case google.maps.GeocoderStatus.ZERO_RESULTS :
                            resolve(results[0]);
                            //const { formatted_address } = this.selectedPlace = results[0];
                            break;
                        default:
                            resolve(false);
                            break;
                    }
                });
            });
        },
        async fetchPredictions(query) {
            return new Promise((resolve, reject) => {
                this.serviceLoading = true;

                this.googleAutocomplete.getPlacePredictions(
                    this.getAutcompleteRequest(query),
                    (...args) => {
                        this.serviceLoading = false;

                        resolve(...args);
                    }
                );
            });
        },
        getAutcompleteRequest(query) {
            return {
                input: query,
            };
        },

        async getGeolocation(callback) {
            if (typeof callback !== "function") callback = function () {};

            if (
                document.location.protocol.indexOf("https") < 0 &&
                !navigator.geolocation
            ) {
                callback(false);
                return false;
            }

            var timeout = 10000;
            var _t = setTimeout(function () {
                callback(false);
            }, timeout);

            navigator.geolocation.getCurrentPosition(
                function (position) {
                    clearTimeout(_t);

                    callback({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                },
                function (e) {
                    clearTimeout(_t);

                    callback(false, e);
                },
                {
                    enableHighAccuracy: true,
                    timeout: timeout,
                    maximumAge: 0,
                }
            );
        },

        async reverseGeocode(pos, callback) {
            if (typeof callback !== "function") callback = function () {};

            var latlng = {
                lat: parseFloat(pos.lat),
                lng: parseFloat(pos.lng),
            };
            this.googleGeocoder.geocode(
                { location: latlng },
                function (results, status) {
                    var result = results[1];
                    if (status !== "OK" || !result) {
                        return callback(false);
                    }
                    callback(result);
                }
            );
        },
    },
};
</script>
